define((require) => {
    "use strict";

    const AnimationController = require("shared/ui/experience/widgets/animations/AnimationController");

    /**
     * The animation controller for zoom in.
     *
     * @class ZoomInAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.INTRO, // We're scaling from 0 to 1.0, hence "intro"

        descriptor() {
            return {
                fromTo: [{scale: 0}, {scale: 1}]
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/zoomIn/ZoomInAnimationController.js